import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* setStudyState(action) {
    if (yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setStudyState',
        parameter: {
            subjectId: action.subjectId,
            studyState: action.studyState,
            weeksGoalId: action.weeksGoalId,
        },
    }
    const data = yield call(http.post, info);

    if (data.statusCode === 200){
        if (action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setStudyState",
            statusCode: data.statusCode,
            error: data.error,
        });
        if (action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}
export const setStudyStateSaga = takeEvery('SetStudyState_Saga', setStudyState);

function* setFavSubject(action) {
    if (yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setFavSubject',
        parameter: {
            subjectId: action.subjectId,
            favFlg: action.favFlg,
        },
    }
    const data = yield call(http.post, info);

    if (data.statusCode === 200){
        if (action.onSuccess) {
            action.onSuccess(data.subjectId);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setFavSubject",
            statusCode: data.statusCode,
            error: data.error,
        });
        if (action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}
export const setFavSubjectSaga = takeEvery('SetFavSubject_Saga', setFavSubject);
